
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Search } from 'lucide-react';

const Recruitment: React.FC = () => {
  return (
    <section id="recruitment" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#FFC222] font-bold mb-4">RECRUITMENT</p>
          <h2 className="text-4xl md:text-6xl font-black mb-6">인액터스가 찾는 미래의 리더</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          <div className="bg-zinc-900 p-10 rounded-3xl border-t-4 border-[#FFC222]">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-2">
              <span className="text-[#FFC222]">Core Target</span>
            </h3>
            <ul className="space-y-6">
              <li className="flex gap-4">
                <CheckCircle2 className="text-[#FFC222] shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">소셜 벤처/스타트업 설립자</p>
                  <p className="text-zinc-400 text-sm">직접 비즈니스를 운영하며 실무 끝단의 경험을 쌓고 싶은 분</p>
                </div>
              </li>
              <li className="flex gap-4">
                <CheckCircle2 className="text-[#FFC222] shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">성과 지향적 실천가</p>
                  <p className="text-zinc-400 text-sm">본인의 아이디어를 주체적으로 실현하고, 수치화된 성과를 만들어내고 싶은 분</p>
                </div>
              </li>
              <li className="flex gap-4">
                <CheckCircle2 className="text-[#FFC222] shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">장기적 몰입가</p>
                  <p className="text-zinc-400 text-sm">방학 포함 만 1년 이상 연속 활동을 통해 진정한 성장을 이루고자 하는 분</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-zinc-900 p-10 rounded-3xl border border-zinc-800">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-2">
              <span className="text-zinc-400">Potential Target</span>
            </h3>
            <ul className="space-y-6">
              <li className="flex gap-4">
                <Search className="text-zinc-500 shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">올라운더 성장</p>
                  <p className="text-zinc-400 text-sm">프로젝트 매니징, 발표, 데이터 분석 등 실무 역량을 기초부터 다지고 싶은 분</p>
                </div>
              </li>
              <li className="flex gap-4">
                <Search className="text-zinc-500 shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">스타트업 전과정 경험</p>
                  <p className="text-zinc-400 text-sm">마케팅, 인사, 회계, 영업 등 운영의 전 과정을 경험해보고 싶은 분</p>
                </div>
              </li>
              <li className="flex gap-4">
                <Search className="text-zinc-500 shrink-0" size={24} />
                <div>
                  <p className="font-bold text-white">밀도 높은 청춘</p>
                  <p className="text-zinc-400 text-sm">열정적인 동료들과 함께 사회 문제를 해결하며 청춘을 보내고 싶은 분</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#FFC222] to-yellow-500 p-12 rounded-[2rem] text-black">
           <h3 className="text-3xl font-black mb-10 text-center">선발 절차</h3>
           <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
              <div className="flex flex-col items-center gap-2">
                 <div className="w-16 h-16 rounded-full bg-white/30 flex items-center justify-center font-black text-2xl">1</div>
                 <p className="font-bold text-lg md:text-xl text-center">1차 온라인<br/>서류 접수</p>
              </div>
              <div className="hidden md:block w-8 lg:w-12 h-0.5 bg-black/20"></div>
              <div className="flex flex-col items-center gap-2">
                 <div className="w-16 h-16 rounded-full bg-white/30 flex items-center justify-center font-black text-2xl">2</div>
                 <p className="font-bold text-lg md:text-xl text-center">2차 온라인<br/>서류 접수</p>
              </div>
              <div className="hidden md:block w-8 lg:w-12 h-0.5 bg-black/20"></div>
              <div className="flex flex-col items-center gap-2">
                 <div className="w-16 h-16 rounded-full bg-white/30 flex items-center justify-center font-black text-2xl">3</div>
                 <p className="font-bold text-lg md:text-xl text-center">오프라인 면접</p>
              </div>
              <div className="hidden md:block w-8 lg:w-12 h-0.5 bg-black/20"></div>
              <div className="flex flex-col items-center gap-2">
                 <div className="w-16 h-16 rounded-full bg-black flex items-center justify-center font-black text-2xl text-[#FFC222]">4</div>
                 <p className="font-bold text-lg md:text-xl text-center">최종 합격</p>
              </div>
           </div>
        </div>
      </div>
    </section>
  );
};

export default Recruitment;
